var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbtacked = function SvgThumbtacked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7611 6.91336L10.4425 3.83349H11.5417C11.8868 3.83349 12.1667 3.55368 12.1667 3.20849V1.9585C12.1667 1.61331 11.8868 1.3335 11.5417 1.3335H4.45833C4.11315 1.3335 3.83333 1.61331 3.83333 1.9585V3.20849C3.83333 3.55368 4.11315 3.83349 4.45833 3.83349H5.55747L5.23885 6.91336C3.97565 7.50068 3 8.55383 3 9.87515C3 10.2203 3.27982 10.5002 3.625 10.5002H7.16666V13.2087C7.16666 13.241 7.17419 13.2729 7.18867 13.3018L7.81367 14.5518C7.89025 14.705 8.1096 14.7053 8.18635 14.5518L8.81135 13.3018C8.82581 13.2729 8.83334 13.241 8.83335 13.2087V10.5002H12.375C12.7202 10.5002 13 10.2203 13 9.87515C13 8.54226 12.0109 7.49443 10.7611 6.91336Z",
    fill: "#EC7963"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbtacked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbtacked.4232b031.svg";
export { ForwardRef as ReactComponent };